export default {
      id: "arrow-left-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }